import React, { useState, useEffect } from 'react';
import { storage } from '../utils/storage';

function AdminDashboard({ onClose }) {
  const [users, setUsers] = useState({});
  const [selectedUser, setSelectedUser] = useState(null);
  const [userLogins, setUserLogins] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAllData();
  }, []);

  const loadAllData = async () => {
    setLoading(true);
    const allUsers = await storage.getAllUsers();
    setUsers(allUsers);
    setLoading(false);
  };

  const viewUserDetails = async (email) => {
    setSelectedUser(email);
    const logins = await storage.getUserLogins(email);
    setUserLogins(logins);
  };

  const getTotalAssessments = (user) => {
    return user.assessments ? user.assessments.length : 0;
  };

  const getLastActivity = (user) => {
    if (user.lastActivity) {
      return new Date(user.lastActivity).toLocaleDateString();
    }
    return 'Never';
  };

  if (loading) {
    return <div>Loading admin data...</div>;
  }

  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2>Admin Dashboard - User Database</h2>
        <button onClick={onClose} style={{ padding: '8px 16px' }}>Close Admin</button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
        {/* Users List */}
        <div>
          <h3>All Users ({Object.keys(users).length})</h3>
          <div style={{ border: '1px solid #ddd', borderRadius: '8px', overflow: 'hidden' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead style={{ backgroundColor: '#f5f5f5' }}>
                <tr>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Email</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Assessments</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Last Activity</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(users).map(([email, user]) => (
                  <tr key={email} style={{ borderBottom: '1px solid #eee' }}>
                    <td style={{ padding: '12px' }}>{email}</td>
                    <td style={{ padding: '12px' }}>{getTotalAssessments(user)}</td>
                    <td style={{ padding: '12px' }}>{getLastActivity(user)}</td>
                    <td style={{ padding: '12px' }}>
                      <button 
                        onClick={() => viewUserDetails(email)}
                        style={{ padding: '4px 8px', fontSize: '12px' }}
                      >
                        View Details
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* User Details */}
        <div>
          {selectedUser ? (
            <div>
              <h3>User Details: {selectedUser}</h3>
              
              {/* User Info */}
              <div style={{ marginBottom: '20px', padding: '15px', border: '1px solid #ddd', borderRadius: '8px' }}>
                <h4>Account Information</h4>
                <p><strong>Email:</strong> {selectedUser}</p>
                <p><strong>Created:</strong> {users[selectedUser]?.createdAt ? new Date(users[selectedUser].createdAt).toLocaleDateString() : 'Unknown'}</p>
                <p><strong>Last Activity:</strong> {getLastActivity(users[selectedUser])}</p>
                <p><strong>Total Assessments:</strong> {getTotalAssessments(users[selectedUser])}</p>
              </div>

              {/* Login History */}
              <div style={{ marginBottom: '20px', padding: '15px', border: '1px solid #ddd', borderRadius: '8px' }}>
                <h4>Login History ({userLogins.length})</h4>
                <div style={{ maxHeight: '150px', overflowY: 'auto' }}>
                  {userLogins.length > 0 ? (
                    userLogins.slice(-10).reverse().map((login, index) => (
                      <div key={index} style={{ padding: '5px 0', borderBottom: '1px solid #eee', fontSize: '14px' }}>
                        <strong>{new Date(login.timestamp).toLocaleString()}</strong>
                      </div>
                    ))
                  ) : (
                    <p>No login history available</p>
                  )}
                </div>
              </div>

              {/* Assessment History */}
              <div style={{ padding: '15px', border: '1px solid #ddd', borderRadius: '8px' }}>
                <h4>Assessment History</h4>
                <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                  {users[selectedUser]?.assessments?.length > 0 ? (
                    users[selectedUser].assessments.map((assessment, index) => (
                      <div key={index} style={{ padding: '10px', marginBottom: '10px', backgroundColor: '#f9f9f9', borderRadius: '4px' }}>
                        <div><strong>{assessment.title}</strong></div>
                        <div style={{ fontSize: '12px', color: '#666' }}>
                          Completed: {new Date(assessment.timestamp || assessment.date).toLocaleString()}
                        </div>
                        <div style={{ fontSize: '12px', color: '#666' }}>
                          Questions: {assessment.answers?.length || 0}
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>No assessments completed</p>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div style={{ padding: '50px', textAlign: 'center', color: '#666' }}>
              <p>Select a user to view their details</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;